import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { MutationFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

export interface ReEvaluateLoanParams {
  loanChecklistRuleId: string;
}

export interface ReEvaluateLoanResponse {
  success: boolean;
}

const reEvaluateLoan: MutationFunction<boolean, ReEvaluateLoanParams> = async (
  args,
) => {
  if (isMockServices()) return (await mock(_mockType)).success;

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<ReEvaluateLoanResponse>(
    `/loan-checklist-rules/evaluate`,
    {
      method: 'POST',
      body: {
        id: args.loanChecklistRuleId,
      },
    },
  );

  if (response.data) return response.data.success;

  throw new Error('Failed to re-evaluate loan');
};

export default reEvaluateLoan;

const _mockType: ReEvaluateLoanResponse = {
  success: true,
};
